export default __webpack_public_path__ + "static/media/goodMeter.2e6203be.png";